/**
 * @module FE-CU61_ショートカットアクション画面
 */
import Header from '../../components/header/Header.vue';
import PCFooter from '@/components/footer/PCFooter';

export default {
  name: 'shortcutAction',
  components: {
    Header,
    PCFooter,
  },
  data() {
    return {
      isProcess: true,
      securityUnitExecutionResults: [],
      isResultsObtained: false,
    };
  },
  /** @type {Methods} */
  methods: {
    /**
     * 確認ダイアログ表示処理
     * @param {*} text 確認メッセージ
     */
    callSaveMessageDialog: async function (text) {
      await this.$informationDialog(text);
      this.$router.replace({ path: '/top' });
    },
    /**
     * 一括警備設定アクション
     * @param {*} securityStatus 警備状態
     */
    async callBulkSecuritySettingApi(securityStatus) {
      // APP_CU6101 一括警備設定_登録処理
      let apiData = await this.APP_CU6101(securityStatus);

      if (typeof apiData.contentsInfo !== 'undefined') {
        // 一括警備設定アクション結果が3の場合はエラーE0002を表示する
        if (apiData.contentsInfo.bulkSecuritySettingResult === '3') {
          this.isResultsObtained = true;
          this.callSaveMessageDialog(
            this.$vuetify.lang.t('$vuetify.FECU61ショートカットアクション画面.E0002')
          );
          return;
        }

        // 一括警備設定アクション結果が1以外の場合はエラーE0001を表示する
        if (apiData.contentsInfo.bulkSecuritySettingResult !== '1') {
          this.isResultsObtained = true;
          this.callSaveMessageDialog(
            this.$vuetify.lang.t('$vuetify.FECU61ショートカットアクション画面.E0001')
          );
          return;
        }
        let promiseList = [];
        this.$store.commit('requestApi/setInterruptionFlag', false);
        this.securityUnitExecutionResults = [];
        let hasEmptySendCommandKey = false;
        apiData.contentsInfo.unitCommandInfo.forEach((unitCommand) => {
          if (
            typeof unitCommand.sendCommandKey == 'undefined' ||
            unitCommand.sendCommandKey == '' ||
            typeof unitCommand.sendCustomerNumber == 'undefined' ||
            unitCommand.sendCustomerNumber == ''
          ) {
            hasEmptySendCommandKey = true;
          }
        });
        // 警備ユニットコマンド情報.送信コマンドキーが空のものがあった場合エラーE0003を表示する
        if (hasEmptySendCommandKey) {
          this.isResultsObtained = true;
          this.callSaveMessageDialog(
            this.$vuetify.lang.t('$vuetify.FECU61ショートカットアクション画面.E0003')
          );
          return;
        }
        apiData.contentsInfo.unitCommandInfo.forEach((unitCommand) => {
          let params = {
            token: sessionStorage.getItem('token'),
            terminalInfo: localStorage.getItem('terminalInfo')
              ? localStorage.getItem('terminalInfo')
              : '',
            sendCustomerNumber: unitCommand.sendCustomerNumber,
            sendCommandKey: unitCommand.sendCommandKey,
            apiId: 20,
            alarmType: 0,
            districtSplitNumber: '',
            securityAreaId: '',
          };
          promiseList.push(this.APP_CU6101_CO9915(params));
        });

        if (promiseList.length != 0) {
          await Promise.all(promiseList).catch((error) => {
            console.log(error);
          });
        }

        if (!this.$store.getters[`requestApi/getInterruptionFlag`]) {
          // 正常
          let successResult = true;
          this.securityUnitExecutionResults.forEach((result) => {
            if (result !== 0) {
              successResult = false;
            }
          });
          if (successResult) {
            this.isResultsObtained = true;
            // APP_CO9915の警備状態変更コマンド実行結果が全てOK⇒正常終了メッセージ
            this.callSaveMessageDialog(
              this.$vuetify.lang.t('$vuetify.FECU61ショートカットアクション画面.成功')
            );
          } else {
            this.isResultsObtained = true;
            // APP_CO9915の警備状態変更コマンド実行結果にOKではないものがある⇒エラーE000３
            this.callSaveMessageDialog(
              this.$vuetify.lang.t('$vuetify.FECU61ショートカットアクション画面.E0003')
            );
          }
        } else {
          if (this.securityUnitExecutionResults.length != 0) {
            this.$store.commit('requestApi/setInterruptionFlag', false);
            this.isResultsObtained = true;
            // 90秒繰り返してもAPP_CO9915の警備ユニット実行結果が-1のままのものがあるとき、一つでも警備ユニット実行結果が-1ではないものがある場合⇒エラーE000３
            this.callSaveMessageDialog(
              this.$vuetify.lang.t('$vuetify.FECU61ショートカットアクション画面.E0003')
            );
          } else {
            this.$store.commit('requestApi/setInterruptionFlag', false);
            this.isResultsObtained = true;
            // 90秒繰り返してもAPP_CO9915の警備ユニット実行結果が-1のままのものがあるとき、全ての警備ユニット実行結果が-1の場合⇒エラーE000２
            this.callSaveMessageDialog(
              this.$vuetify.lang.t('$vuetify.FECU61ショートカットアクション画面.E0002')
            );
          }
        }
      }
    },
    /**
     * 一括警備設定アクション(APP_CU6101)
     * @param {*} securityStatus 警備状態
     * @returns レスポンス
     */
    APP_CU6101: async function (securityStatus) {
      let param = '/api/shortcutAction/bulkSecuritySettings';
      this.saveDisplayDistrictInfoList = [];

      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        securityStatus: securityStatus,
      };

      let method = 'post';
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
          },
          (error /* eslint-disable-line */) => {
            // 異常系の処理
            this.$_abnormality(error.response.status);
          }
        );
      return apiData;
    },
    /**
     * APP_CU6101に対する警備ユニットコマンド実行結果確認(APP_CO9915)
     * @param {*} params リクエストのパラメータ
     * @returns レスポンス
     */
    APP_CU6101_CO9915: async function (params) {
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/postSecurityUnitExecutionResult`, {
          params: params,
        })
        .then((response /* eslint-disable-line */) => {
          apiData = response;
          if (
            typeof apiData.contentsInfo.securityUnitExecutionResult !== 'undefined' &&
            apiData.contentsInfo.securityUnitExecutionResult == 0
          ) {
            let securityStatus = 0;
            apiData.contentsInfo.commandExecutionResult.app_cu6101.securityDistrictInfo.forEach(
              (securityDistrict) => {
                if (securityDistrict.securityStatusChangeResult !== 0) {
                  securityStatus = securityDistrict.securityStatusChangeResult;
                }
              }
            );
            this.securityUnitExecutionResults.push(securityStatus);
          } else if (
            typeof apiData.contentsInfo.securityUnitExecutionResult !== 'undefined' &&
            apiData.contentsInfo.securityUnitExecutionResult !== 0
          ) {
            if (apiData.contentsInfo.securityUnitExecutionResult !== -1) {
              this.securityUnitExecutionResults.push(
                apiData.contentsInfo.securityUnitExecutionResult
              );
            }

            if (!this.$store.getters[`requestApi/getInterruptionFlag`]) {
              this.$store.commit('requestApi/setInterruptionFlag', true);
            }
          } else if (!this.$store.getters[`requestApi/getInterruptionFlag`]) {
            this.$store.commit('requestApi/setInterruptionFlag', true);
          }
        });
      return apiData;
    },
  },
  async mounted() {
    if (!this.$isMobileApp) {
      this.$router.replace({
        path: '/sorry',
      });
      return;
    }
    this.isProcess = true;
    await this.callBulkSecuritySettingApi('F');
    this.isProcess = false;
  },
  beforeRouteLeave(to, from, next) {
    if (this.isProcess) {
      next(false);
    } else {
      if (this.isResultsObtained && sessionStorage.getItem('redirectPath') === '/shortcutAction') {
        sessionStorage.removeItem('redirectPath');
      }
      next();
    }
  },
};
